/* eslint-disable */
import { errorMsg } from '../constants/messages';

const partnerOrderMembersFormData = [
  {
    name: 'name',
    label: 'Member Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Member Name', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'group',
    label: 'Order',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Group Id',
      allowAddRecordClick: false,
      displayKey: 'groupCode',
    },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },
  {
    name: 'ageGroup',
    label: 'Age Group',
    fieldType: {
      name: 'select',
      options: [
        { value: 'Adult', name: 'Adult' },
        { value: 'Minor', name: 'Minor' },
      ],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Age Group', allowAddRecordClick: false },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'status',
    label: 'Status',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Status', allowAddRecordClick: false },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'referenceNumber',
    label: 'Reference Number',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Reference Number', allowAddRecordClick: false },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'review',
    label: 'Details',
    fieldType: {
      name: 'reviewPartnerOrderMember',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Details', columnType: 'clickHere', allowAddRecordClick: false },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
];

export { partnerOrderMembersFormData };
